// Package imports:
import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt } from '@fortawesome/pro-light-svg-icons';
// Style imports:
// import './MyBookmarks.scss';
// Component imports:
import Table from 'react-bootstrap/Table';
import EditBookmarkModal from '../bookmarks/EditBookmarkModal';
import DeleteBookmarkModal from '../bookmarks/DeleteBookmarkModal';
// Service imports:
import { formatDate, turnDateToSimpleTime } from '../../services/utils';
// Action imports:
import { setSelectedTick } from '../../redux-store/actions/dashboardActions';
// Type imports:
import { RootState } from '../../redux-store/reducers';
import { IBookmark } from '../../types/api/BookmarkTypes';
import { sortTickData } from '../../services/sortUtils';

interface IOwnProps {
    symbol: string,
};
type ReduxProps = ConnectedProps<typeof connector>
type Props = ReduxProps & IOwnProps;

interface IState {
    editBookmark: IBookmark | null,
    deleteBookmark: IBookmark | null
}

/**
 * This component displays My Bookmarks under alerts/Bookmarks tab **Found NavBar Alerts (Alerts/Bookmarks)**
 * - Subcomponent of SigtiRange
 */
class MyBookmarks extends React.Component<Props, IState> {
    constructor (props: Props) {
        super(props);
        this.state = {
            editBookmark: null,
            deleteBookmark: null
        }
    }

    displayRows = () => {
        const { bookmarks, currentTradingDay, symbol, setSelectedTick, selectedTick } = this.props;
        
        if (bookmarks === null || bookmarks === 'waiting') {
            return (
                <tr className='NoClick'>
                    <td className='text-left' colSpan={5}>
                        Loading...
                    </td>
                </tr>
            )
        }

        const bookmarksBySymbol = bookmarks.filter(bookmark => (
            bookmark.symbol === symbol
            && turnDateToSimpleTime(new Date(bookmark.timestamp)) === currentTradingDay
        ));

        const sortedBookmarks = sortTickData(bookmarksBySymbol);

        const jsxRows = sortedBookmarks.map((bookmark) => ((
                <tr
                    key={bookmark.id}
                    className={(bookmark === selectedTick) ? 'current' : undefined}
                    onClick={() => setSelectedTick(bookmark)}
                >
                    <td>
                        {formatDate(bookmark.timestamp, true, true)}
                    </td>
                    <td>{bookmark.bmcomment}</td>
                    <td>
                        <FontAwesomeIcon
                            icon={faEdit}
                            className='BookmarkIcon'
                            onClick={(e: React.MouseEvent) => {
                                e.stopPropagation();
                                this.setState({ editBookmark: bookmark });
                            }}
                        />
                        <FontAwesomeIcon
                            icon={faTrashAlt}
                            className='BookmarkIcon'
                            onClick={(e: React.MouseEvent) => {
                                e.stopPropagation();
                                this.setState({ deleteBookmark: bookmark });
                            }}
                        />
                    </td>
                </tr>
            )
        ));

        if (jsxRows.length === 0) {
            return (
                <tr className='NoClick'>
                    <td className='text-left EmptyTableText' colSpan={3}>No Bookmarks</td>
                </tr>
            )
        }

        return jsxRows;
    }

    render () {
        const { editBookmark, deleteBookmark } = this.state;
        return (
            <div id='MyBookmarks'>
                <h5 className='SectionTitle'>Bookmarks</h5>
                <Table className='CompressedTable ClickableRows'>
                    <thead>
                        <tr>
                            <th>Timestamp</th>
                            <th>Comment</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.displayRows()}
                    </tbody>
                </Table>
                {
                    (editBookmark !== null) // if
                    ? (
                        <EditBookmarkModal
                            bookmark={editBookmark}
                            onHide={() => this.setState({ editBookmark: null })}
                        />
                    ) : (deleteBookmark !== null) // else if
                    ? (
                        <DeleteBookmarkModal
                            bookmark={deleteBookmark}
                            onHide={() => this.setState({ deleteBookmark: null })}
                        />
                    ) : null
                }
            </div>
        );
    }
}

function mapStateToProps({ alertReducer, bookmarkReducer, dashboardReducer }: RootState) {
    const { alertsByDate } = alertReducer;
    const { bookmarks } = bookmarkReducer;
    const { currentTradingDay, selectedTick } = dashboardReducer;
    return {
        alertsByDate,
        bookmarks,
        currentTradingDay,
        selectedTick
    };
}

const connector = connect(mapStateToProps, { setSelectedTick });
export default connector(MyBookmarks);
